var _rect, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGel = function SvgGel(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5513_107421",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 16,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 2,
    width: 16,
    height: 12,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5513_107421)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2V14H16V2H0Z",
    fill: "#F7FCFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5513_107421",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 16,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2V14H16V2H0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5513_107421)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 2H9V7H16V9H9V14H7V9H0V7H7V2Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99932 10.611L6.09998 10.5V11.5C6.09998 11.5 4.99932 11.4311 4.99932 11.451C4.99932 11.4709 5.09998 12.5 5.09998 12.5H4.09998L4.18009 11.5H3.09998V10.5L4.18009 10.611L4.09998 9.5H5.09998L4.99932 10.611Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99932 4.61098L6.09998 4.5V5.5C6.09998 5.5 4.99932 5.43108 4.99932 5.45098C4.99932 5.47088 5.09998 6.5 5.09998 6.5H4.09998L4.18009 5.5H3.09998V4.5L4.18009 4.61098L4.09998 3.5H5.09998L4.99932 4.61098Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9993 4.61098L13.1 4.5V5.5C13.1 5.5 11.9993 5.43108 11.9993 5.45098C11.9993 5.47088 12.1 6.5 12.1 6.5H11.1L11.1801 5.5H10.1V4.5L11.1801 4.61098L11.1 3.5H12.1L11.9993 4.61098Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9993 10.611L13.1 10.5V11.5C13.1 11.5 11.9993 11.4311 11.9993 11.451C11.9993 11.4709 12.1 12.5 12.1 12.5H11.1L11.1801 11.5H10.1V10.5L11.1801 10.611L11.1 9.5H12.1L11.9993 10.611Z",
    fill: "#E31D1C"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGel);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "GEL.7924848a3fc096f4e0c64e86abf7e031.svg";